import Yt from "./trigger-condition.js";
export default class lr {
  constructor(t) {
    this.du = t;
  }
  Gl(t) {
    return null == this.du || Yt.pu(t[0], this.du);
  }
  static fromJson(t) {
    return new lr(t ? t.campaign_id : null);
  }
  ss() {
    return this.du;
  }
}
